import * as control from './navigationControl';

export const nextPage = () => (dispatch, props) => {
    dispatch(control.goToNextPage(props().navigationStep));
};

export const previousPage = () => (dispatch, props) => {
    dispatch(control.goToPreviousPage(props().navigationStep));
};
